var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#77C720"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_5156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_5156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.95 29C25.8667 29 23.8083 28.5458 21.775 27.6375C19.7417 26.7292 17.8917 25.4417 16.225 23.775C14.5583 22.1083 13.2708 20.2583 12.3625 18.225C11.4542 16.1917 11 14.1333 11 12.05C11 11.75 11.1 11.5 11.3 11.3C11.5 11.1 11.75 11 12.05 11H16.1C16.3333 11 16.5417 11.0792 16.725 11.2375C16.9083 11.3958 17.0167 11.5833 17.05 11.8L17.7 15.3C17.7333 15.5667 17.725 15.7917 17.675 15.975C17.625 16.1583 17.5333 16.3167 17.4 16.45L14.975 18.9C15.3083 19.5167 15.7042 20.1125 16.1625 20.6875C16.6208 21.2625 17.125 21.8167 17.675 22.35C18.1917 22.8667 18.7333 23.3458 19.3 23.7875C19.8667 24.2292 20.4667 24.6333 21.1 25L23.45 22.65C23.6 22.5 23.7958 22.3875 24.0375 22.3125C24.2792 22.2375 24.5167 22.2167 24.75 22.25L28.2 22.95C28.4333 23.0167 28.625 23.1375 28.775 23.3125C28.925 23.4875 29 23.6833 29 23.9V27.95C29 28.25 28.9 28.5 28.7 28.7C28.5 28.9 28.25 29 27.95 29Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group 3.a9f8fbd6ac83e4c77e83d6313d964a8e.svg";
export { ForwardRef as ReactComponent };